module.exports = __webpack_public_path__ + "img/cacc-science.1d553052.jpg";